import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NbDateService } from '@nebular/theme';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  userForm: any = FormGroup;
  showField: boolean = false;
  isShowPaswordField: boolean = true;
  id: any;
  // date: any;
  age: any;
  max: Date;
  showPassword: any = true;
  isBlocked = [
    { name: 'True', value: true },
    { name: 'False', value: false },
  ];
  isSuspecious = [
    { name: 'True', value: true },
    { name: 'False', value: false },
  ];
  isSkipAge = [
    { name: 'Yes — skip age verification', value: true },
    { name: 'No — apply age verification', value: false },
  ];
  blockBtn: any = 'Block User';
  constructor(
    private router: ActivatedRoute,
    private service: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    public route: Router,
    public date: DatePipe,
    private dateService: NbDateService<Date>,
    private dialog: MatDialog,
    private location: Location
  ) {
    this.router.params.subscribe((route: any) => {
      this.id = route['id'];
    });
    this.max = this.dateService.today();
  }
  ngOnInit() {
    this.userForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      age: new FormControl(''),
      phone: new FormControl('', Validators.required),
      dateofbirth: new FormControl(''),
      suspicious: new FormControl(),
      cprNumber: new FormControl(''),
      adminComments: new FormControl(''),
      skipAgeVerification: new FormControl(false),
    });
    if (this.id) {
      this.getUserById();
    }
  }

  get buttonTitle() {
    return this.id ? 'Edit User' : 'Add User';
  }
  private goBack(): void {
    const returnUrl = this.router.snapshot.queryParamMap.get('returnUrl');
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
      this.route.navigateByUrl(returnUrl);
    } else {
      this.location.back();
    }
  }

  onBack() {
    this.goBack();
  }

  onSubmit() {
    if (this.id) {
      this.showField = true;
      this.spinner.show();
      var userForm = {
        name: this.userForm.value.name,
        email: this.userForm.value.email,
        password: this.userForm.value.password,
        country: this.userForm.value.country,
        phone: this.userForm.value.phone,
        age: this.userForm.value.age,
        dateofbirth: this.userForm.value.dateofbirth,
        birthdate: this.userForm.value.dateofbirth,
        suspicious: this.userForm.value.suspicious,
        cprNumber: this.userForm.value.cprNumber,
        adminComments: this.userForm.value.adminComments,
        skipAgeVerification: this.userForm.value.skipAgeVerification,
      };
      // console.log(this.userForm.value.dateofbirth, "updatedate")
      this.service
        .putRequest(`${ApiUrl.updateUser}${this.id}`, userForm)
        .subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.goBack();
            // this.route.navigate(['/users']);
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(err.error.response.message);
          }
        );
    } else {
      this.spinner.show();
      var userForm = {
        name: this.userForm.value.name,
        email: this.userForm.value.email,
        password: this.userForm.value.password,
        country: this.userForm.value.country,
        phone: this.userForm.value.phone,
        age: this.userForm.value.age,
        dateofbirth: this.userForm.value.dateofbirth,
        birthdate: this.userForm.value.dateofbirth,
        suspicious: this.userForm.value.suspicious,
        cprNumber: this.userForm.value.cprNumber,
        adminComments: this.userForm.value.adminComments,
        skipAgeVerification: this.userForm.value.skipAgeVerification,
      };
      if (this.userForm.valid) {
        this.service.postRequest(ApiUrl.addUser, userForm).subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.goBack();
            // this.route.navigate(['/users']);
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(err?.error?.response?.message);
          }
        );
      } else {
        this.toastr.error('Please fill all required fields.');
        this.spinner.hide();
      }
    }
  }
  calculateAge(dateOfBirth: Date) {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    this.userForm.get('age').setValue(age);
    this.userForm.patchValue({
      dateofbirth: birthDate,
    });
  }

  getUserById() {
    this.spinner.show();
    this.isShowPaswordField = false;
    this.showField = true;
    this.service.getRequest(`${ApiUrl.getUserById}${this.id}`).subscribe(
      (res: any) => {
        const data = res.response?.data;
        this.blockBtn = data.isblocked ? 'Unblock User' : 'Block User';

        if (data) {
          this.userForm.patchValue({
            name: data.name,
            email: data.email,
            password: data.password,
            country: data.country,
            phone: data.phone,
            age: data.age,
            dateofbirth: data.dateofbirth
              ? new Date(data.dateofbirth)
              : (data.birthdate ? new Date(data.birthdate) : null),
            suspicious: data.suspicious,
            cprNumber: data.cprNumber,
            adminComments: data.adminComments || '',
            skipAgeVerification: data.skipAgeVerification ?? false,
          });
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error(err?.error?.response?.message);
      }
    );
  }

  openChangePassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: '50%',
      data: { id: this.id },
    });
  }

  viewUserCards() {
    this.route.navigate(['/user-cards', this.id]);
  }

  onPhoneInput(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 20);
    this.userForm.get('phone')?.setValue(input.value);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  forceLogout(event: any) {
    let text: any =
      event == 'Block'
        ? ` you want to ${this.blockBtn} ?`
        : `You want to Force Logout ?`;
    Swal.fire({
      title: 'Are you sure?',
      text: text,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
    }).then((result) => {
      if (result.value) {
        let data = {
          userId: this.id,
          type: event,
        };
        this.service.postRequest(ApiUrl.forcelogoutUser, data).subscribe(
          (res: any) => {
            this.toastr.success('Updated Successfully');
            this.getUserById();
          },
          (err: any) => {
            this.toastr.error(err.error.error);
          }
        );
      }
    });
  }
}
